import { OrderDetail, OrderStatus, VoidItem } from '~/types/Order';
import http from '~/http/services/pos';
import { ApiResponse } from '~/types/Api';
import { PaymentMethod } from '../../../types/Payment';

const URL_API_ORDER_PREFIX = '/api/v1/order';
const VOID_API_URL = '/api/v1/void';
const ORDER_DELIVERY_URL = '/api/v1/order/delivery';

// Fetch order list.
type OrderListResponse = ApiResponse<OrderDetail[]>;
export const fetchOrderList = (params: {
  status?: OrderStatus;
  startTime?: number;
  endTime?: number;
  sort?: string;
  order?: string;
}) => {
  return http.get<OrderListResponse>(URL_API_ORDER_PREFIX, {
    params,
  });
};

// Fetch order detail.
type OrderDetailResponse = ApiResponse<OrderDetail>;
export const fetchOrderDetail = (id: string) => {
  return http.get<OrderDetailResponse>(`${URL_API_ORDER_PREFIX}/${id}`);
};

// Void order.
type VoidOrderResponse = ApiResponse<null>;
export const voidOrder = (body: {
  level: 'order' | 'item';
  orderId: string;
  voidBy: string;
  batchIndex?: number;
  itemIndex?: number;
  item?: VoidItem | null;
  actionToken: string;
}) => {
  return http.patch<VoidOrderResponse>(`${VOID_API_URL}`, body);
};

// Pay order.
type PayOrderResponse = ApiResponse<null>;
export const payOrder = (
  orderId: string,
  body: {
    roundingAmount: number;
    payments: {
      method: PaymentMethod;
      amount: number;
      cash?: number;
      change?: number;
      description?: string;
    }[];
  }
) => {
  return http.patch<PayOrderResponse>(`/api/v2/orders/${orderId}/pay`, body);
};

// Order information.
type UpdateOrderInformationResponse = ApiResponse<null>;
export const updateOrderInformation = (
  orderId: string,
  body: {
    orderType: string;
    tableNo: number;
    customerName: string;
  }
) => {
  return http.patch<UpdateOrderInformationResponse>(
    `api/v1/order/${orderId}/informations`,
    body
  );
};

// Order delivery.
type OrderDeliveryResponse = ApiResponse<null>;
export const updateOrderDelivery = (body: {
  orderId: string;
  type: string;
  price: number;
}) => {
  return http.patch<OrderDeliveryResponse>(ORDER_DELIVERY_URL, body);
};

// Refund.
type RefundOrderResponse = ApiResponse<null>;
export const refundOrder = ({
  orderId,
  actionToken,
}: {
  orderId: string;
  actionToken: string;
}) => {
  return http.patch<RefundOrderResponse>(`/api/v2/orders/${orderId}/refund`, {
    actionToken,
  });
};

// Order tax.
type UpdateOrderTaxResponse = ApiResponse<OrderDetail>;
export const updateOrderTax = (orderId: string, isTaxApplied: boolean) => {
  return http.patch<UpdateOrderTaxResponse>(`/api/v2/orders/${orderId}/tax`, {
    isApplied: isTaxApplied,
  });
};
